//changed due to package upgrade
import React from 'react';
import { alpha, Box, Button } from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import Grid from '@mui/material/Grid';
import IntlMessages from '@projectK/helpers/IntlMessages';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Form } from 'formik';
import AppTextField from '@projectK/components/AppTextField';
import {
  isActualSuperAdmin,
  useRolePermissions,
  hasPermission,
  isActualAdmin,
} from '@projectK/context/RolesProvider';
import PropTypes from 'prop-types';

const ChangePasswordForm = ({ companyTheme, resetForm, user }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const { rolePermissions } = useRolePermissions();
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showRetypeNewPassword, setShowRetypeNewPassword] =
    React.useState(false);

  const onShowOldPassword = () => {
    setShowPassword(!showPassword);
  };

  const onDownOldPassword = (event) => {
    event.preventDefault();
  };

  const onShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const onDownNewPassword = (event) => {
    event.preventDefault();
  };

  const onShowRetypeNewPassword = () => {
    setShowRetypeNewPassword(!showRetypeNewPassword);
  };

  const onDownRetypeNewPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Form autoComplete='off'>
      <AppGridContainer spacing={4} sx={{ mt: 2 }}>
        {!isActualSuperAdmin(user) && !isActualAdmin(user) && (
          <>
            <Grid size={{ xs: 12, md: 6 }}>
              <AppTextField
                type={showPassword ? 'text' : 'password'}
                name='old_password'
                sx={{
                  width: '100%',
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={onShowOldPassword}
                          onMouseDown={onDownOldPassword}
                          edge='end'
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                label={<IntlMessages id='common.oldPassword' />}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ p: '0 !important' }} />
          </>
        )}
        <Grid size={{ xs: 12, md: 6 }}>
          {' '}
          <AppTextField
            type={showNewPassword ? 'text' : 'password'}
            name='password'
            sx={{
              width: '100%',
            }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={onShowNewPassword}
                      onMouseDown={onDownNewPassword}
                      edge='end'
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            label={<IntlMessages id='common.newPassword' />}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <AppTextField
            type={showRetypeNewPassword ? 'text' : 'password'}
            name='repeat_password'
            sx={{
              width: '100%',
            }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={onShowRetypeNewPassword}
                      onMouseDown={onDownRetypeNewPassword}
                      edge='end'
                    >
                      {showRetypeNewPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            label={<IntlMessages id='common.retypeNewPassword' />}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {hasPermission(
              rolePermissions,
              'My Locker - Account Info',
              'update',
            ) && (
              <Button
                sx={{
                  position: 'relative',
                  minWidth: 100,
                  backgroundColor: companyTheme
                    ? companyTheme.primary.main
                    : '#2196f3',
                  '&:hover': {
                    backgroundColor: companyTheme
                      ? alpha(companyTheme.primary.main, 0.8) // Adjust the alpha value as needed
                      : alpha('#2196f3', 0.8),
                  },
                }}
                variant='contained'
                type='submit'
              >
                Save
              </Button>
            )}
            <Button
              sx={{
                position: 'relative',
                minWidth: 100,
                ml: 2.5,
                borderColor: companyTheme
                  ? companyTheme.primary.main
                  : '#2196f3',
                '&:hover': {
                  borderColor: companyTheme
                    ? alpha(companyTheme.primary.main, 0.8)
                    : alpha('#2196f3', 0.8),
                },
                color: companyTheme ? companyTheme.primary.main : '#2196f3',
              }}
              onClick={(e) => {
                e.preventDefault();
                // Reset the form back to its initial state
                resetForm();
              }}
              variant='outlined'
            >
              <IntlMessages id='common.cancel' />
            </Button>
          </Box>
        </Grid>
      </AppGridContainer>
    </Form>
  );
};

export default ChangePasswordForm;

ChangePasswordForm.propTypes = {
  companyTheme: PropTypes.isRequired,
  resetForm: PropTypes.isRequired,
  user: PropTypes.isRequired,
};
